import { render, staticRenderFns } from "./RetencionCreate.vue?vue&type=template&id=2d7059f4&scoped=true"
import script from "./RetencionCreate.vue?vue&type=script&lang=js"
export * from "./RetencionCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7059f4",
  null
  
)

export default component.exports